import useRealtimeEvents from './useRealtimeEvents';

const TOURNAMENT_EVENTS = new Set([
  'tournament_created',
  'tournament_updated',
  'tournament_ended',
  'tournament_deleted',
]);

/**
 * Subscribe to tournament WebSocket events so admin + public UIs stay in sync
 * without a manual refresh (close/reopen registration, participants, delete, etc.).
 *
 * @param {(data: { type: string, tournament?: object, tournament_id?: string }) => void} onEvent
 * @param {{ enabled?: boolean }} [options]
 */
export default function useTournamentRealtime(onEvent, options = {}) {
  useRealtimeEvents(TOURNAMENT_EVENTS, onEvent, options);
}
